export default __webpack_public_path__ + "static/media/3.74a35a67.jpg";